import { useAtomValue } from 'jotai';
import RollupVerificationStatus from 'components/rollup-verification-status/rollup-verification-status';
import { rollupVerificationAtomFamily } from './atoms';
import { SubtractNRI } from './types';

interface SlotRollupVerificationStatusProps {
  subtracts: SubtractNRI[];
  type: 'nri' | 'wi';
  /** Forwarded to the tooltip so it can escape a clipping ancestor (DataTable cells). */
  autoAlign?: boolean;
}

export const SlotRollupVerificationStatus = ({
  subtracts,
  type,
  autoAlign = false,
}: SlotRollupVerificationStatusProps) => {
  const { totalSteps, markedCorrectTotal, markedIncorrectTotal } = useAtomValue(
    rollupVerificationAtomFamily({ subtracts, type })
  );

  if (totalSteps === 0) return null;

  return (
    <RollupVerificationStatus
      totalSteps={totalSteps}
      markedCorrectTotal={markedCorrectTotal}
      markedIncorrectTotal={markedIncorrectTotal}
      autoAlign={autoAlign}
    />
  );
};
